<template>
  <div class="loader">
    <header class="header">
      <div class="left">
        <img alt="EMPIR" src="../assets/EMPIR-Euramet-Europe.jpg">
        <p>
          <!-- This project has received funding from the EMPIR programme
          co-financed by the Participating States and from the European
          Union’s Horizon 2020 research and innovation programme. -->
        </p>
      </div>
      <div class="right">
        <img alt="EMPIR" src="../assets/Logo_Pollen_bleu.png">
      </div>
      <div class="end" />
    </header>
    <i class="el-icon-loading spinner" />
    <Footer fixed />
  </div>
</template>

<script>
import axios from 'axios'

import Header from './Header.vue'
import Footer from './Footer.vue'


import config from '../config.json'

const checkConnection = (user, zenodoAuth) =>
  new Promise((resolve, reject) => {
    if (user && user.accessToken) {
      axios.get('/deposit/depositions', {
        params: {
          access_token: user.accessToken,
        },
        baseURL: config.baseURL,
        headers: {
          'Content-Type': 'application/json',
        },
      }).then(() => {
        resolve(user)
      }).catch((error) => {
        reject()
      })
    } else {
      zenodoAuth.token.getToken(window.location).then(({ data }) => {
        // the page just comes from the OAuth2 portal
        if (data) {
          const userData = data.user.replace(/'/g, '"').replace(/ u/, '')
          const newUser = {
            ...user,
            id: JSON.parse(userData).id,
            tokenType: data.token_type,
            accessToken: data.access_token,
          }
          resolve(newUser)
        } else {
          throw new Error('error')
        }
      }).catch((/* error */) => {
        reject()
      })
    }

  })


export default {
  name: 'Loader',
  props: {
    zenodoAuth: Object,
  },
  mounted() {
    const user = this.$cookies.get('user')
    checkConnection(user, this.zenodoAuth)
      .then((user) => {
        this.$cookies.set('user', user)
        if (user.name) {
          this.$router.push('/upload/list')
        } else {
          this.$router.push('/account/first')
        }
      }).catch(() => {
        this.$router.push('/connect')
      })
  },
  components: {
    Header,
    Footer,
  },
}
</script>
<style lang="scss">

@import "../themes.scss";

$logoHeight: 70px;

.loader {
  .header {
    padding: 10px;
    text-align: left;
    .left {
      float: left;
      display: inline-block;
      text-align: left;
      font-size: 0.8em;
      font-style: italic;
      img {
        height: $logoHeight;
      }
    }

    .right {
      float: right;
      img {
        height: 50px;
      }
    }

    .end {
      clear: both;
    }
  }
  .spinner {
    color: $primary;
    font-size: 2em;
  }
}

</style>
